import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TourManagementOptionsSidebar from "../components/tour/TourManagementSidebarOptionsSidebar";
import TourManagementAvailabilityHeader from "../components/TourManagementAvailabilityHeader";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setFeeValue, setOptionsData } from "../reducer/tourReducer";
// import { tourCommision } from "../utils/contants";
import { usePackage } from "../hooks/usePackage";
import { Switch } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useOptions } from "../hooks/useOptions";
import { resetOptionEdit } from "../reducer/tourEditReducer";

function TourManagementPackageAvailabilityPricePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { calculateNetProfit } = usePackage();
  const { feeValue, optionsData, PrepackageDataId, packageData } = useSelector(
    (state: RootState) => state.tour
  );
  const {
    tourEdit,
    optionId,
    id: editPackageId,
  } = useSelector((state: RootState) => state.edit);

  useEffect(() => {
    if (location.state && location.state.optionData) {
      dispatch(setOptionsData(location.state.optionData));
    }
  }, [location.state, dispatch]);

  const [loading, setLoading] = useState<Boolean>(false);
  const { getPlatformFee } = usePackage();
  const progressref = useRef(18);
  const { createPreOptions } = useOptions();
  // const [feeValue, setFeeValue] = useState<number | undefined>()

  // Ensure groupPricing is always an array
  const groupPricing = optionsData.groupPricing || [];

  useOnLoadPage({ tabActive: "create" });

  const onContinue = async () => {
    let updatedPackageData = {
      ...optionsData,
      _id: optionsData._id,
      progress: Number(progressref.current),
    };
    // Clean up if fixed
    if (updatedPackageData.pricingOption === "fixed") {
      delete updatedPackageData.pricingCategories;
      delete updatedPackageData.pricePerAgeGroup;
      delete updatedPackageData.groupPricing;
      delete updatedPackageData.pricing;
    }

    const updatedPackageData2 = {
      ...optionsData,
      ...updatedPackageData,
    };

    dispatch(setOptionsData(updatedPackageData));
    try {
      if (tourEdit) {
        dispatch(resetOptionEdit());
        dispatch(setOptionsData(updatedPackageData2));
        const pkgId = packageData._id;
        navigate(`/manage/product/${pkgId}/${optionId}`, {
          state: {
            fromEdit: true,
            option: updatedPackageData2,
            packageId: pkgId,
          },
        });
        return;
      } else {
        await createPreOptions(updatedPackageData);
        navigate(Paths.tourManagementPackageOptionsCancelationPolicy);
      }
    } catch (error) {
      console.error("Error saving package:", error);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleUpdateSamePriceTierMin = (index: number, min: number) => {
    let data = optionsData.samePricing?.tierPrice
      ? [...optionsData.samePricing.tierPrice]
      : [];
    let obj = optionsData.samePricing?.tierPrice
      ? {
          ...optionsData.samePricing?.tierPrice[index],
          minTickets: min,
        }
      : {};
    data[index] = obj;
    dispatch(
      setOptionsData({
        ...optionsData,
        samePricing: { ...optionsData.samePricing, tierPrice: data },
      })
    );
  };

  const handleUpdateSamePriceTierMax = (index: number, max: number) => {
    let data = optionsData.samePricing?.tierPrice
      ? [...optionsData.samePricing.tierPrice]
      : [];
    let obj = optionsData.samePricing?.tierPrice
      ? {
          ...optionsData.samePricing?.tierPrice[index],
          maxTickets: max,
        }
      : {};
    data[index] = obj;
    dispatch(
      setOptionsData({
        ...optionsData,
        samePricing: { ...optionsData.samePricing, tierPrice: data },
      })
    );
  };

  const handleAddSamePriceTier = () => {
    let obj = {
      minTickets: 0,
      maxTickets: 0,
      price: 0,
    };
    let data = optionsData.samePricing?.tierPrice
      ? [...optionsData.samePricing.tierPrice, obj]
      : [obj];
    dispatch(
      setOptionsData({
        ...optionsData,
        samePricing: { ...optionsData.samePricing, tierPrice: data },
      })
    );
  };

  const handleRemoveSamePriceTier = (index: number) => {
    let data = optionsData.samePricing?.tierPrice
      ? [...optionsData.samePricing.tierPrice]
      : [];

    let newData = data.filter((_, idx) => idx !== index);
    dispatch(
      setOptionsData({
        ...optionsData,
        samePricing: { ...optionsData.samePricing, tierPrice: newData },
      })
    );
  };

  const isTierPricingEnabledInAge = (index: number): boolean => {
    let value = false;
    if (optionsData.pricing) {
      value = optionsData.pricing[index]?.tier ? true : false;
    }
    return value;
  };

  const updateAgeCategoryTierPricingAvailability = (index: number) => {
    if (!optionsData.pricing) return;
    let data = [...optionsData.pricing];
    if (!data[index]) return;
    let cell = { ...data[index], tier: data[index].tier ? false : true };

    data[index] = cell;
    dispatch(
      setOptionsData({
        ...optionsData,
        pricing: data,
      })
    );
  };

  const handleUpdateAgeSignlePrice = (index: number, price: number) => {
    if (!optionsData.pricing) return;
    let data = [...optionsData.pricing];
    if (!data[index]) return;
    const netPrice = calculateNetProfit(price);
    let cell = {
      ...data[index],
      singlePrice: price,
      calculatedPrice: netPrice,
    };

    data[index] = cell;

    dispatch(
      setOptionsData({
        ...optionsData,
        pricing: data,
      })
    );
  };

  const handleAddAgePriceTier = (index: number) => {
    if (!optionsData.pricing) return;
    let agePricings = [...optionsData.pricing];
    if (!agePricings[index]) return;
    let ageToBeUpdated = agePricings[index];

    let obj = {
      minTickets: 0,
      maxTickets: 0,
      price: 0,
      calculatedPrice: 0,
    };
    let tiers = ageToBeUpdated.tierPrice
      ? [...ageToBeUpdated.tierPrice, obj]
      : [obj];

    let updatedAge = { ...ageToBeUpdated, tierPrice: tiers };

    agePricings[index] = updatedAge;

    dispatch(
      setOptionsData({
        ...optionsData,
        pricing: agePricings,
      })
    );
  };

  const handleRemoveAgePriceTier = (index: number, idx: number) => {
    if (!optionsData.pricing) return;
    let agePricings = [...optionsData.pricing];
    if (!agePricings[index]) return;
    let ageToBeUpdated = agePricings[index];
    let tiers = ageToBeUpdated.tierPrice ? [...ageToBeUpdated.tierPrice] : [];

    let filteredTier = tiers.filter((_, ind) => idx !== ind);
    let updatedAge = { ...ageToBeUpdated, tierPrice: filteredTier };

    agePricings[index] = updatedAge;

    dispatch(
      setOptionsData({
        ...optionsData,
        pricing: agePricings,
      })
    );
  };

  const handleUpdateAgePriceTierMin = (
    index: number,
    idx: number,
    min: number
  ) => {
    if (!optionsData.pricing) return;
    let agePricings = [...optionsData.pricing];
    if (!agePricings[index]) return;
    let ageToBeUpdated = agePricings[index];
    let tiers = ageToBeUpdated.tierPrice ? [...ageToBeUpdated.tierPrice] : [];

    tiers[idx] = { ...tiers[idx], minTickets: min };

    let updatedAge = { ...ageToBeUpdated, tierPrice: tiers };

    agePricings[index] = updatedAge;

    dispatch(
      setOptionsData({
        ...optionsData,
        pricing: agePricings,
      })
    );
  };

  const handleUpdateAgePriceTierMax = (
    index: number,
    idx: number,
    max: number
  ) => {
    if (!optionsData.pricing) return;
    let agePricings = [...optionsData.pricing];
    if (!agePricings[index]) return;
    let ageToBeUpdated = agePricings[index];
    let tiers = ageToBeUpdated.tierPrice ? [...ageToBeUpdated.tierPrice] : [];

    tiers[idx] = { ...tiers[idx], maxTickets: max };

    let updatedAge = { ...ageToBeUpdated, tierPrice: tiers };

    agePricings[index] = updatedAge;

    dispatch(
      setOptionsData({
        ...optionsData,
        pricing: agePricings,
      })
    );
  };

  const handleUpdateAgePriceTierPrice = (
    index: number,
    idx: number,
    price: number
  ) => {
    if (!optionsData.pricing) return;
    let agePricings = [...optionsData.pricing];
    if (!agePricings[index]) return;
    let ageToBeUpdated = agePricings[index];
    const netPrice = Math.round(calculateNetProfit(price));
    let tiers = ageToBeUpdated.tierPrice ? [...ageToBeUpdated.tierPrice] : [];
    tiers[idx] = { ...tiers[idx], price: price, calculatedPrice: netPrice };
    let updatedAge = { ...ageToBeUpdated, tierPrice: tiers };

    agePricings[index] = updatedAge;

    dispatch(
      setOptionsData({
        ...optionsData,
        pricing: agePricings,
      })
    );
  };

  useEffect(() => {
    const fetchPlatformFee = async () => {
      try {
        setLoading(true);
        const response = await getPlatformFee({ setLoading });
        setLoading(false);
        dispatch(setFeeValue(response.value));
      } catch (error) {
        console.error("Failed to fetch platform fee:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlatformFee();
  }, []);

  console.log("package in price page", optionsData);
  console.log("optiondata samepricing in price page", optionsData.samePricing);
  console.log("packagepricing", optionsData.groupPricing);

  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementOptionsSidebar selected={4} />
        <div className={Classname.detail}>
          <TourManagementAvailabilityHeader active={3} />
          <div className={Classname.title}>Set the price for your activity</div>
          {optionsData.priceByGroup ? (
            <>
              {groupPricing.map((group, groupIndex) => (
                <div
                  key={groupIndex}
                  className="w-full rounded-lg border border-gray-200 p-4 my-4"
                >
                  <div className="font-bold text-gray-900">
                    {group.name || `Group ${groupIndex + 1}`}
                  </div>
                  <div className="flex flex-wrap gap-4 lg:gap-10 mt-3 mb-3">
                    <div className={Classname.items}>
                      <div className="text-gray-400">Number of members</div>
                      <div className="flex items-center">
                        <input
                          type="number"
                          placeholder="to"
                          min={1}
                          value={group.to || ""}
                          className="px-2 h-8 rounded-sm w-16 border border-gray-300"
                          onChange={(e) => {
                            const updatedGroupPricing = [...groupPricing];
                            updatedGroupPricing[groupIndex] = {
                              ...updatedGroupPricing[groupIndex],
                              to: Math.abs(parseInt(e.target.value)) || 0,
                            };
                            dispatch(
                              setOptionsData({
                                ...optionsData,
                                groupPricing: updatedGroupPricing,
                              })
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex gap-10">
                      <div className={Classname.items}>
                        <div className="text-gray-400">Customer pays</div>
                        <div className={Classname.gridItem}>
                          <input
                            type="number"
                            className={Classname.input}
                            value={group.price || ""}
                            onChange={(e) => {
                              const updatedGroupPricing = [...groupPricing];
                              updatedGroupPricing[groupIndex] = {
                                ...updatedGroupPricing[groupIndex],
                                price: Math.abs(parseInt(e.target.value)) || 0,
                              };
                              dispatch(
                                setOptionsData({
                                  ...optionsData,
                                  groupPricing: updatedGroupPricing,
                                })
                              );
                            }}
                          />{" "}
                          USD
                        </div>
                      </div>
                    </div>
                    <div className={Classname.items}>
                      <div className="text-gray-400">Commission (%)</div>
                      <div className={Classname.gridItem}>
                        <div className="flex min-w-[50px] items-center h-8 border bg-gray-200 rounded-md px-2">
                          {feeValue}
                        </div>
                        %
                      </div>
                    </div>
                    <div className={Classname.items}>
                      <div className="text-gray-400">Net Payment (USD)</div>
                      <div className={Classname.gridItem}>
                        <div className="flex min-w-[50px] items-center h-8 border bg-gray-200 rounded-md px-2">
                          {calculateNetProfit(
                            group.price || 0
                          ).toLocaleString()}
                        </div>
                        USD
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : optionsData.samePrice ? (
            <>
              {/* Same price for every age group */}
              <div className="w-full rounded-lg border border-gray-200 p-4">
                <div className="flex gap-2 items-center w-full justify-end">
                  <div className="font-bold text-gray-500">
                    Enable tier pricing
                  </div>
                  <Switch
                    color="primary"
                    checked={optionsData.samePricing?.tier}
                    onChange={() => {
                      let data = {
                        ...optionsData.samePricing,
                        tier: optionsData.samePricing?.tier ? false : true,
                      };
                      dispatch(
                        setOptionsData({
                          ...optionsData,
                          samePricing: data,
                        })
                      );
                    }}
                  />
                </div>
                {optionsData.samePricing?.tier ? (
                  <>
                    {optionsData.samePricing.tierPrice?.map(
                      (pricing, index) => (
                        <div
                          className="flex flex-wrap gap-4 lg:gap-10 mt-3 mb-3"
                          key={index}
                        >
                          <div className={Classname.items}>
                            <div className="text-gray-400">
                              Number of tickets
                            </div>
                            <div className="flex items-center">
                              <input
                                type="number"
                                placeholder="min"
                                min={0}
                                value={pricing.minTickets}
                                className="px-2 h-8 rounded-sm w-16 border border-gray-300"
                                onChange={(e) => {
                                  handleUpdateSamePriceTierMin(
                                    index,
                                    Math.abs(parseInt(e.target.value))
                                  );
                                }}
                              />
                              <span className="mx-2">to</span>
                              <input
                                type="number"
                                placeholder="max"
                                min={0}
                                value={pricing.maxTickets}
                                className="px-2 h-8 rounded-sm w-16 border border-gray-300"
                                onChange={(e) => {
                                  handleUpdateSamePriceTierMax(
                                    index,
                                    Math.abs(parseInt(e.target.value))
                                  );
                                }}
                              />
                            </div>
                          </div>

                          <div className="flex gap-10">
                            <div className={Classname.items}>
                              <div className="text-gray-400">Customer pays</div>
                              <div className={Classname.gridItem}>
                                <input
                                  type="number"
                                  className={Classname.input}
                                  value={pricing.price}
                                  onChange={(e) => {
                                    if (!optionsData?.samePricing) return;
                                    if (!optionsData.samePricing.tierPrice)
                                      return;
                                    const tierPrice = Math.abs(
                                      parseInt(e.target.value)
                                    );
                                    const netPrice =
                                      calculateNetProfit(tierPrice);
                                    let tierData = [
                                      ...optionsData.samePricing.tierPrice,
                                    ];
                                    let newData = {
                                      ...tierData[index],
                                      price: Math.abs(parseInt(e.target.value)),
                                      calculatedPrice: netPrice,
                                    };
                                    tierData[index] = newData;

                                    let data = {
                                      ...optionsData?.samePricing,
                                      tierPrice: tierData,
                                    };
                                    dispatch(
                                      setOptionsData({
                                        ...optionsData,
                                        samePricing: data,
                                      })
                                    );
                                  }}
                                />{" "}
                                USD
                              </div>
                            </div>
                          </div>
                          <div className={Classname.items}>
                            <div className="text-gray-400">Commission (%)</div>
                            <div className={Classname.gridItem}>
                              <div className="flex min-w-[50px] items-center h-8 border bg-gray-200 rounded-md px-2">
                                {feeValue}
                              </div>
                              %
                            </div>
                          </div>
                          <div className={Classname.items}>
                            <div className="text-gray-400">
                              Net Payment (USD)
                            </div>
                            <div className={Classname.gridItem}>
                              <div className="flex min-w-[50px] items-center h-8 border bg-gray-200 rounded-md px-2">
                                {calculateNetProfit(
                                  pricing.price
                                ).toLocaleString()}
                              </div>
                              USD
                            </div>
                          </div>

                          <span
                            className="flex text-end font-bold text-red-500 cursor-pointer"
                            onClick={() => handleRemoveSamePriceTier(index)}
                          >
                            - Remove Tier
                          </span>
                        </div>
                      )
                    )}
                  </>
                ) : (
                  <div className="flex flex-wrap gap-4 lg:gap-10 mt-6 ">
                    <div className="flex gap-10">
                      <div className={Classname.items}>
                        <div className="text-gray-400">Customer pays</div>
                        <div className={Classname.gridItem}>
                          <input
                            type="number"
                            className={Classname.input}
                            value={optionsData.samePricing?.singlePrice}
                            onChange={(e) => {
                              const singlePrice = Math.abs(
                                parseInt(e.target.value)
                              );
                              const netPrice = Math.round(
                                calculateNetProfit(singlePrice)
                              );

                              const newSamePricing = {
                                ...(optionsData.samePricing || {}),
                                singlePrice,
                                calculatedPrice: netPrice,
                              };

                              dispatch(
                                setOptionsData({
                                  ...optionsData,
                                  samePricing: newSamePricing,
                                })
                              );
                            }}
                          />{" "}
                          USD
                        </div>
                      </div>
                    </div>
                    <div className={Classname.items}>
                      <div className="text-gray-400">Commission (%)</div>
                      <div className={Classname.gridItem}>
                        <div className="flex min-w-[50px] items-center h-8 border bg-gray-200 rounded-md px-2">
                          {feeValue}
                        </div>
                        %
                      </div>
                    </div>
                    <div className={Classname.items}>
                      <div className="text-gray-400">Net Payment (USD)</div>
                      <div className={Classname.gridItem}>
                        <div className="flex min-w-[50px] items-center h-8 border bg-gray-200 rounded-md px-2">
                          {calculateNetProfit(
                            optionsData.samePricing?.singlePrice
                          ).toLocaleString()}
                        </div>
                        USD
                      </div>
                    </div>
                  </div>
                )}
                {optionsData.samePricing?.tier && (
                  <span
                    className="flex w-full text-end font-bold text-primary cursor-pointer pt-2"
                    onClick={handleAddSamePriceTier}
                  >
                    + Add tier
                  </span>
                )}
              </div>
            </>
          ) : (
            <>
              {/* Pricing classified by age group */}
              {optionsData.pricing?.map((agePricing, index) => (
                <div
                  className="w-full rounded-lg border border-gray-200 p-4 my-4"
                  key={index}
                >
                  <div className="flex gap-2 items-center w-full justify-between">
                    <span className="font-bold text-gray-900">
                      {agePricing.category}
                    </span>
                    <div className="flex items-center">
                      <div className="font-bold text-gray-500">
                        Enable tier pricing
                      </div>
                      <Switch
                        color="primary"
                        checked={isTierPricingEnabledInAge(index)}
                        onChange={() =>
                          updateAgeCategoryTierPricingAvailability(index)
                        }
                      />
                    </div>
                  </div>
                  {isTierPricingEnabledInAge(index) ? (
                    <>
                      {agePricing.tierPrice?.map((pricing, idx) => (
                        <div
                          className="flex flex-wrap gap-4 lg:gap-10 mt-3 mb-3"
                          key={index}
                        >
                          <div className={Classname.items}>
                            <div className="text-gray-400">
                              Number of tickets
                            </div>
                            <div className="flex items-center">
                              <input
                                type="number"
                                placeholder="min"
                                min={0}
                                value={pricing.minTickets}
                                className="px-2 h-8 rounded-sm w-16 border border-gray-300"
                                onChange={(e) => {
                                  handleUpdateAgePriceTierMin(
                                    index,
                                    idx,
                                    Math.abs(parseInt(e.target.value))
                                  );
                                }}
                              />
                              <span className="mx-2">to</span>
                              <input
                                type="number"
                                placeholder="max"
                                min={0}
                                value={pricing.maxTickets}
                                className="px-2 h-8 rounded-sm w-16 border border-gray-300"
                                onChange={(e) => {
                                  handleUpdateAgePriceTierMax(
                                    index,
                                    idx,
                                    Math.abs(parseInt(e.target.value))
                                  );
                                }}
                              />
                            </div>
                          </div>

                          <div className="flex gap-10">
                            <div className={Classname.items}>
                              <div className="text-gray-400">Customer pays</div>
                              <div className={Classname.gridItem}>
                                <input
                                  type="number"
                                  className={Classname.input}
                                  value={pricing.price}
                                  onChange={(e) => {
                                    handleUpdateAgePriceTierPrice(
                                      index,
                                      idx,
                                      Math.abs(parseInt(e.target.value))
                                    );
                                  }}
                                />{" "}
                                USD
                              </div>
                            </div>
                          </div>
                          <div className={Classname.items}>
                            <div className="text-gray-400">Commission (%)</div>
                            <div className={Classname.gridItem}>
                              <div className="flex min-w-[50px] items-center h-8 border bg-gray-200 rounded-md px-2">
                                {feeValue}
                              </div>
                              %
                            </div>
                          </div>
                          <div className={Classname.items}>
                            <div className="text-gray-400">
                              Net Payment (USD)
                            </div>
                            <div className={Classname.gridItem}>
                              <div className="flex min-w-[50px] items-center h-8 border bg-gray-200 rounded-md px-2">
                                {calculateNetProfit(
                                  pricing.price
                                ).toLocaleString()}
                              </div>
                              USD
                            </div>
                          </div>

                          <span
                            className="flex text-end font-bold text-red-500 cursor-pointer"
                            onClick={() => handleRemoveAgePriceTier(index, idx)}
                          >
                            - Remove Tier
                          </span>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="flex flex-wrap gap-4 lg:gap-10 mt-6 ">
                      <div className="flex gap-10">
                        <div className={Classname.items}>
                          <div className="text-gray-400">Customer pays</div>
                          <div className={Classname.gridItem}>
                            <input
                              type="number"
                              className={Classname.input}
                              value={agePricing?.singlePrice}
                              onChange={(e) =>
                                handleUpdateAgeSignlePrice(
                                  index,
                                  Math.abs(parseInt(e.target.value))
                                )
                              }
                            />{" "}
                            USD
                          </div>
                        </div>
                      </div>
                      <div className={Classname.items}>
                        <div className="text-gray-400">Commission (%)</div>
                        <div className={Classname.gridItem}>
                          <div className="flex min-w-[50px] items-center h-8 border bg-gray-200 rounded-md px-2">
                            {feeValue}
                          </div>
                          %
                        </div>
                      </div>
                      <div className={Classname.items}>
                        <div className="text-gray-400">Net Payment (USD)</div>
                        <div className={Classname.gridItem}>
                          <div className="flex min-w-[50px] items-center h-8 border bg-gray-200 rounded-md px-2">
                            {calculateNetProfit(
                              agePricing?.singlePrice
                            ).toLocaleString()}
                          </div>
                          USD
                        </div>
                      </div>
                    </div>
                  )}
                  {isTierPricingEnabledInAge(index) && (
                    <span
                      className="flex w-full text-end font-bold text-primary cursor-pointer pt-2"
                      onClick={() => handleAddAgePriceTier(index)}
                    >
                      + Add tier
                    </span>
                  )}
                </div>
              ))}
            </>
          )}

          <div className={Classname.buttonsContainer}>
            <button className={Classname.saveButton} onClick={handleBack}>
              Back
            </button>
            <button className={Classname.continueButton} onClick={onContinue}>
              Save and {!tourEdit ? "Continue" : "Exit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageAvailabilityPricePage;

const Classname = {
  items: "flex flex-col items-start gap-4",
  gridContainer: "grid grid-cols-4 gap-4",
  gridItem: "flex text-sm items-center justify-center h-8 gap-2 ",
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  input: "flex w-32 h-8 border border-gray-300 rounded-md px-2",
  inputSmall: "flex w-12 h-8 border bg-gray-200 rounded-md px-1",
  inputPrice: "flex w-24 h-8 border bg-gray-200 rounded-md px-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6",
  description: "flex text-base mb-4",
  buttonsContainer: "flex flex-1 justify-between lg:justify-end gap-3 mt-10",
  highlightButton:
    "font-bold flex items-center gap-2 cursor-pointer text-primary1 py-4",
  saveButton:
    "h-12 px-6 flex items-center justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
